import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination, CodeSnippet } from "../common";
import './Updates.css';

const Updates_3_41_0 = () => {
  return (
    <div>
      <PageTitle title='3.41.0' />

      <ParaTitle paraTitle='Dashboard Updates & New Features' />
      <Paragraph paragraph='2025-05-07' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
          Risk Managers can hide reporter names
          <p>Give risk managers the ability to hide the Reporter Name when protecting the reporter's identity is important.
            The system will still work as intended but it gives Risk Managers a chance to protect the reporters
            if conflict of interest occurs</p>
        </li>
        <li>
          Organization Dashboards
          <p>Have a new dashboard view for Organization Managers.
            It consists of aggregated numbers from the facilities that belong to the organization,
            which gives a organization a quick page where they can check on the organization and see how the organization is doing.
          </p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Enhance export options
          <p>Risk Managers and above have the ability to export all events, regardless of the organization.
            The export includes <CodeSnippet codeSnippet="HS14other" /> and <CodeSnippet codeSnippet="DE105other" /> entries.
          </p>
          {/* <ParaImageDialog src='/tutorial_image/updates-3-40-0.png' /> */}
        </li>
        <li>Back up user permissions before server updates
          <p>Fix a bug where users randomly lose permissions.
            Investigation suggests that the issue is triggered by recent server updates,
            as indicated by the last recorded activity.
          </p>
        </li>
        <li>Include patient form for Near Miss & Unsafe Condition Events
          <p>
            For NEAR MISS and UNSAFE CONDITION event types, an additional question - Was a patient involved? - is added.
            If yes, proceed to answer patient form. Otherwise, continue normal question flow.
            Facilities face different challenges across their hospitals so a rigid question format structure does not work for all of them.
            Adding this extra question will allow users to enter additional data that the administrators need.
          </p>
        </li>
        <li>Add <CodeSnippet codeSnippet="Suicide Attempt" /> option to State question set
        </li>
      </ul>

      <Pagination
        pagination={{
          prev: { name: 'Updates: 3.42.0', link: '/updates/3.42.0' },
          next: { name: 'Updates: 3.40.0', link: '/updates/3.40.0' }
        }}
      />
    </div>

  )
}

export default Updates_3_41_0;